import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardTitle,
  CardText,
  CardFooter,
} from "reactstrap";
import classnames from "classnames";
import img from "../../assets/img/brand/goodybuddy_short.png";
import adminModel from "models/admin.model";
import { helper } from "lib/helper";
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper"; // Import your generic filter function

const AllBooking = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const initialExperience = location.state?.experience || {};
  const [activeTab, setActiveTab] = useState("1");
  const { id } = useParams();
  const navigate = useNavigate();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [bookingData, setBookingData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [searchQuery, setSearchQuery] = useState("");

  const getBookingDetails = async () => {
    setIsLoading(true);
    await adminModel
      .bookingDetails(id)
      .then((result) => {
        console.log(result, "booking");
        setIsLoading(false);
        if (result) {
          setBookingData(result?.data?.bookings);
        }
      })
      .catch((error) => {
        // console.log(error);
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  // console.log(bookingData,"+++++++++++++++booking")

  // Use your filterItems function to filter data based on the search query
  const filteredDataList = filterItems(bookingData, searchQuery, [
    "buddyname",
    "mob",
    "experienceType",
    "goods",
    "services",
    "audienceFor",
  ]);

  // Calculate the items to display for the current page
  const startIndex = (currentPage - 1) * perPage;
  const endIndex = startIndex + perPage;
  const paginatedDataList = filteredDataList.slice(startIndex, endIndex);

  // Calculate the index of the first and last user on the current page
  const indexOfLastUser = currentPage * perPage;
  const indexOfFirstUser = indexOfLastUser - perPage;

  // Filter users based on search query
  const filteredUsers = filterItems(filteredDataList, searchQuery, [
    "firstName",
    "email",
    "mob",
  ]);
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page when pagination is clicked
  };

  const handleDelete = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          adminModel.bookingDelete(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getBookingDetails();
          });
        }
      });
  };

  useEffect(() => {
    getBookingDetails();
  }, [location]);

  console.log(bookingData, "booking");                                                      

  return (
    <Container className="pt-0" fluid>
      <Card className="shadow">
        {bookingData.length === 0 ? (
          <h3 className="text-center">No Bookings yet</h3>
        ) : (
          <>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S.No</th>
                  {/* <th scope="col">Date</th> */}
                  <th scope="col">User</th>
                  <th scope="col">Booking Date</th>
                  <th scope="col">Time</th>
                  <th scope="col">Status</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {bookingData?.map((item, index) => {
                  return (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      {/* <td>no data</td> */}
                      <td>
                        {item?.user?.firstName} {item?.user?.lastName}
                      </td>
                      <td>
                        {new Date(item?.bookingDate).toLocaleDateString(
                          "en-GB"
                        )}
                      </td>
                      <td>{item?.experienceTime}</td>
                      <td>{item?.status}</td>
                      <td>{item?.price}</td>
                      <td>
                        <Button color="success" size="sm" className="mr-2" onClick={() => navigate('/admin/bookings/view/' + item._id)}> <i className="fa-solid fa-eye"></i></Button>
                        {/* <Button color="primary" size="sm" className="mr-2">Listing</Button> */}
                        {/* <Button color="warning" size="sm" className="mr-2" onClick={() => navigate('/admin/user/edit/' + item._id)}><i className="fa-regular fa-pen-to-square"></i></Button> */}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDelete(item?._id)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              <TablePagination
                totalPages={Math.ceil(filteredUsers.length / perPage)}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                pageUrl="/admin/users?"
              />
            </CardFooter>
          </>
        )}
      </Card>
    </Container>
  );
};

export default AllBooking;
